





















































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import SceneTypeComponent from "@/app/components/manageSpace/components/sceneType.component.vue";
import { i18n } from "@/resources/locales";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { Validate } from "vuelidate-property-decorators";
import { required } from "vuelidate/lib/validators";
import ErrorController from "@/resources/mixins/errorController/errorController";
import UserValidator from "@/resources/mixins/userValidator";
import Loader from "@/resources/mixins/loader/loader";
import { MAX_SIZE_FILE } from "@/resources/constants/system";
import VueTagsInput from "@johmun/vue-tags-input";
import Plans from "@/resources/mixins/plans/plans";
import { PLAN } from "@/resources/constants/plan";
@Component({
  name: "configuration-super-space-component",
  components: { SceneTypeComponent, VueTagsInput },
})
export default class ConfigurationSuperSpaceComponent extends mixins(
  Loader,
  NotificationEvent,
  ErrorController,
  UserValidator,
  Plans
) {
  PLAN = PLAN;
  typePlanes = ["FREE","PAID","DEMO","ENTERPRISE"];
  api = process.env.VUE_APP_API_IMAGE;
  @Validate({ required })
  isMultiWebinarActivated = false;
  showWebinarChangeModal = false;
  openModal = false;
  isRange = false;
  ipFrom = "";
  ipTo = "";
  officeLocationIps = [];
  openConfirmDeleteModal = false;
  loadingDelete = false;
  removeFrom = "";
  removeTo = "";
  loader = false;
  loadingAdd = false;
  activeReserveRoom = true;
  plantName = "";
  plantImageUrl = "" || null;
  plants = [];
  roomName = "";
  rooms = [];
  physicalRooms = [];
  activeReserveRoomAdd = false;
  activeReserveRoomShow = false;
  activeReserveRoomEdit = false;
  currentPlantId = 0;
  creatingRoom = false;
  createRoomOk = false;
  createImageOk = false;
  spaceDefault = null;
  spacesDefault = [];
  selectedPlans = {};
  maxUsersConnected = 0;
  maxSpaces = 0;
  plan = "";
  created() {
    if (this.isSuperSpaceAdmin()) {
      if (this.superSpace && this.superSpace.featurePlan) {
        Object.entries(this.superSpace.featurePlan).forEach(([key, value]) => {
          Vue.set(this.selectedPlans, key, value);
        });
        this.maxSpaces = this.superSpace.featurePlan.maxSpaces;
        this.maxUsersConnected = this.superSpace.featurePlan.maxUsersConnected;
        this.plan = this.superSpace.featurePlan.plan;
      }
    }
  }
  mounted(): void {
    this.spaceDefault = this.superSpace.defaultSpace.id;
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SuperSpaceStore/getSuperSpaceByIdAction", {
      superSpaceId: space ? space.superSpace.id : this.superSpace.id,
      callback: async (response) => {
        // do nothing
      },
      callbackError: (error) => {
        if (error.response && error.response.status == 403) {
          this.checkError(error);
        }
      },
    });
    this.getAllSpaces();
    this.getSuperSpaceById();
    this.getPlant();
  }
  get superSpace(): any {
    let data = null;
    data = this.$store.getters["SuperSpaceStore/getSuperSpace"];
    if (data) {
      this.isMultiWebinarActivated = data.isMultiWebinarActivated;
    }
    return data;
  }
  get space() {
    return this.$store?.getters["SpaceStore/getSpace"];
  }
  /*const space = store?.getters["SpaceStore/getSpace"];
        if (space && space.superSpace && space.superSpace.company !== "CTTI")*/
  destroyed() {
    this.closeTooltip();
  }
  onSaveEnd(): void {
    this.stopLoader(this.$store);
    this.onSuccess(
      i18n.t("notifications.titles.success"),
      i18n.t("notifications.descriptions.spaceUpdate")
    );
  }
  changeMultiWebinarMode() {
    this.startLoader(this.$store);
    this.$store.dispatch("SuperSpaceStore/changeSuperSpaceWebinarModeAction", {
      superSpaceId: this.superSpace.id,
      data: { isMultiWebinarActivated: !this.isMultiWebinarActivated },
      callback: (response) => {
        this.$store.dispatch(
          "SpaceStore/changeMultiWebinarInStore",
          response.data.isMultiWebinarActivated
        );
        this.onSaveEnd();
      },
      callbackError: (error) => {
        this.stopLoader(this.$store);
      },
    });
  }
  getSuperSpaceById() {
    this.loader = true;
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SuperSpaceStore/getSuperSpacesByIdAction", {
      superSpaceId: space ? space.superSpace.id : this.superSpace.id,
      callback: (response) => {
        this.loader = false;
        this.officeLocationIps = response.officeLocationIps
          ? response.officeLocationIps
          : [];
      },
      callbackError: (error) => {
        this.loader = false;
      },
    });
  }
  saveIp() {
    if (!this.ipTo) this.ipTo = this.ipFrom;
    if (
      !this.validateIPaddress(this.ipFrom) ||
      !this.validateIPaddress(this.ipTo)
    ) {
      this.onWarning("", i18n.t("configurationSuperSpace.ipNoValid"));
      return;
    }
    if (
      parseInt(this.ipFrom.replaceAll(".", "")) >
      parseInt(this.ipTo.replaceAll(".", ""))
    ) {
      this.onWarning("", i18n.t("configurationSuperSpace.rangoMax"));
      return;
    }
    const i = this.officeLocationIps.findIndex(
      (e) => e.from === this.ipFrom && e.to === this.ipTo
    );
    if (i == -1) {
      this.officeLocationIps.push({ from: this.ipFrom, to: this.ipTo });
    } else {
      if (this.ipFrom === this.ipTo)
        this.onWarning("", i18n.t("configurationSuperSpace.alreadyExists"));
      else
        this.onWarning(
          "",
          i18n.t("configurationSuperSpace.rangeAlreadyExusts")
        );
      if (!this.isRange) this.ipTo = "";
      return;
    }
    this.loadingAdd = true;
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SuperSpaceStore/updateSuperSpacesAction", {
      superSpaceId: space.superSpace.id,
      data: {
        officeLocationIps: this.officeLocationIps,
      },
      callback: (response) => {
        this.ipFrom = "";
        this.ipTo = "";
        this.loadingAdd = false;
        this.openModal = false;
      },
      callbackError: (error) => {
        this.loadingAdd = false;
        this.openModal = false;
      },
    });
  }
  checkIp() {
    if (this.isRange && this.ipFrom && this.ipTo) return false;
    if (!this.isRange && this.ipFrom) {
      return false;
    }
    return true;
  }
  validateIPaddress(ipaddress) {
    if (
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        ipaddress
      )
    ) {
      return true;
    }
    //alert("You have entered an invalid IP address!");
    return false;
  }
  deleteIp() {
    this.loadingDelete = true;
    for (let index = 0; index < this.officeLocationIps.length; index++) {
      const element = this.officeLocationIps[index];
      if (element.from === this.removeFrom && element.to === this.removeTo) {
        this.officeLocationIps.splice(index, 1);
        index--;
      }
    }
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SuperSpaceStore/updateSuperSpacesAction", {
      superSpaceId: space.superSpace.id,
      data: {
        officeLocationIps: this.officeLocationIps,
      },
      callback: (response) => {
        this.loadingDelete = false;
        this.openConfirmDeleteModal = false;
      },
      callbackError: (error) => {
        this.loadingDelete = false;
        this.openConfirmDeleteModal = false;
      },
    });
  }
  addPlant() {
    this.plants.push({
      title: this.plantName,
      plantImageUrl: "",
    });
  }
  getPlant() {
    if (!this.activeOptionPlan(PLAN.PHYSICAL_ROOM_RESERVATIONS)) return;
    this.startLoader(this.$store);
    this.$store.dispatch("SuperSpaceStore/getPhysicalPlantAndRoomsAction", {
      superSpaceId: this.superSpace.id,
      callback: (response) => {
        this.physicalRooms = response;
        this.stopLoader(this.$store);
      },
      callbackError: (error) => {
        this.stopLoader(this.$store);
        this.onError(
          "",
          i18n.t("notifications.genericError.genericError", {
            code: error.response.status,
          })
        );
        console.log("TTT getPlant KO ", error);
      },
    });
  }
  async createPlant() {
    this.startLoader(this.$store);
    this.$store.dispatch("SuperSpaceStore/createPhysicalPlantAction", {
      superSpaceId: this.superSpace.id,
      data: { name: this.plantName },
      callback: (response) => {
        this.physicalRooms.push({
          id: response.data.id,
          rooms: [],
          image: null,
          name: response.data.name,
        });
        this.createImage(response.data.id);
        this.createRoom(response.data.id);
      },
      callbackError: (error) => {
        this.stopLoader(this.$store);
        console.log("TTT createPlant KO ", error);
        this.onError(
          "",
          i18n.t("notifications.genericError.genericError", {
            code: error.response.status,
          })
        );
      },
    });
  }
  async createImage(plantId: number, isHideLoading = true) {
    if (this.plantImageUrl) {
      const formData = new FormData();
      formData.append("file", this.plantImageUrl[0] || "");
      await this.$store.dispatch("SuperSpaceStore/createPhysicalImageAction", {
        plantId: plantId,
        data: formData,
        callback: (response) => {
          let physicalRoom = this.physicalRooms.find(
            (object) => object.id === plantId
          );
          if (!isHideLoading) {
            physicalRoom.image = response;
            this.stopLoader(this.$store);
            this.closeData();
            this.onSuccess(
              i18n.t("notifications.titles.success"),
              i18n.t("notifications.descriptions.createPhysicalPlantAndRoom")
            );
          } else {
            physicalRoom.image = response;
            this.createImageOk = true;
            this.hideLoading();
          }
        },
        callbackError: (error) => {
          console.log("TTT createImage KO ", error);
          this.stopLoader(this.$store);
          this.onError("", i18n.t("notifications.genericError.updateImage"));
        },
      });
    } else {
      this.createImageOk = true;
    }
  }
  async createRoom(plantId: number) {
    await this.rooms.forEach(async (element) => {
      await this.$store.dispatch("SuperSpaceStore/createPhysicalRoomAction", {
        plantId: plantId,
        data: { name: element.name },
        callback: (response) => {
          let physicalRoom = this.physicalRooms.find(
            (object) => object.id === plantId
          );
          physicalRoom.rooms.push(response.data);
        },
        callbackError: (error) => {
          console.log("TTT createRoom KO ", error);
          this.stopLoader(this.$store);
          this.onError(
            "",
            i18n.t("notifications.genericError.genericError", {
              code: error.response.status,
            })
          );
        },
      });
    });
    this.createRoomOk = true;
    this.hideLoading();
  }
  hideLoading() {
    if (this.createRoomOk && this.createImageOk) {
      this.closeData();
      this.stopLoader(this.$store);
      this.createRoomOk = false;
      this.createImageOk = false;
      this.onSuccess(
        i18n.t("notifications.titles.success"),
        i18n.t("notifications.descriptions.createPhysicalPlantAndRoom")
      );
    }
  }
  async editPlant() {
    this.startLoader(this.$store);
    await this.$store.dispatch("SuperSpaceStore/editPhysicalPlantAction", {
      plantId: this.currentPlantId,
      data: { name: this.plantName },
      callback: (response) => {
        let physicalRoom = this.physicalRooms.find(
          (object) => object.id === this.currentPlantId
        );
        physicalRoom.name = response.name;
        if (
          (this.plantImageUrl && physicalRoom.image === null) ||
          (physicalRoom.image && this.plantImageUrl !== physicalRoom.image.url)
        ) {
          this.createImage(this.currentPlantId, false);
        } else {
          this.stopLoader(this.$store);
          this.onSuccess(
            i18n.t("notifications.titles.success"),
            i18n.t("notifications.descriptions.createPhysicalPlantAndRoom")
          );
        }
      },
      callbackError: (error) => {
        this.stopLoader(this.$store);
        this.onError(
          "",
          i18n.t("notifications.genericError.genericError", {
            code: error.response.status,
          })
        );
        console.log("TTT editPlant KO ", error);
      },
    });
  }
  selectFile(ref): void {
    if (this.$refs[ref]["files"][0]?.size >= MAX_SIZE_FILE) {
      this.onError(
        this.$i18n.t("notifications.titles.error"),
        this.$i18n.t("notifications.errorMessages.maxFileSize")
      );
      return;
    }
    const allImages = ["image/png", "image/jpg", "image/jpeg"];
    if (allImages.indexOf(this.$refs[ref]["files"][0]?.type) < 0) {
      this.onError(
        this.$i18n.t("notifications.titles.error"),
        this.$i18n.t("notifications.errorMessages.fileType")
      );
      return;
    }
    if (this.$refs[ref]["files"].length > 0) {
      this[ref] = this.$refs[ref]["files"];
      const fr = new FileReader();
      setTimeout(() => {
        const img = document.getElementById(ref);
        fr.onload = (event) => {
          if (event) {
            if (img instanceof HTMLImageElement)
              img.src = event ? event?.target.result.toString() : "";
          }
        };
        fr.readAsDataURL(this[ref][0]);
      }, 200);
    }
  }
  addRoom() {
    this.creatingRoom = true;
    this.rooms.push({ id: 0, name: "" });
  }
  removeRoom() {
    this.creatingRoom = false;
    this.rooms.pop();
  }
  showAddPlant() {
    this.activeReserveRoomEdit = false;
    this.activeReserveRoomShow = false;
    this.activeReserveRoomAdd = true;
    this.plantName = "";
    this.roomName = "";
    this.rooms = [];
    this.plantImageUrl = null;
  }
  showHidePlant() {
    this.activeReserveRoomAdd = false;
  }
  checkSavePlant() {
    let isOk = false;
    if (this.activeReserveRoomEdit) {
      if (!this.plantName) isOk = true;
    } else {
      if (!this.plantName || this.rooms.length <= 0) isOk = true;
      this.rooms.forEach((element) => {
        if (!element.name) isOk = true;
      });
    }
    return isOk;
  }
  checkRoom() {
    let isOk = false;
    this.rooms.forEach((element) => {
      if (!element.name) isOk = true;
    });
    return isOk;
  }
  physicalRoomInfo(data) {
    this.creatingRoom = false;
    this.currentPlantId = data.id;
    this.plantName = data.name;
    this.plantImageUrl = data.image && data.image.url ? data.image.url : null;
    this.rooms = data.rooms;
    this.activeReserveRoomAdd = false;
    this.activeReserveRoomShow = true;
    this.activeReserveRoomEdit = false;
  }
  physicalRoomEdit(data) {
    this.creatingRoom = false;
    this.currentPlantId = data.id;
    this.plantName = data.name;
    this.plantImageUrl = data.image && data.image.url ? data.image.url : null;
    this.rooms = data.rooms;
    this.activeReserveRoomAdd = false;
    this.activeReserveRoomShow = false;
    this.activeReserveRoomEdit = true;
  }
  async physicalPlantRemove(data) {
    this.startLoader(this.$store);
    await this.$store.dispatch("SuperSpaceStore/removePhysicalPlantAction", {
      plantId: data.id,
      callback: (response) => {
        this.physicalRooms = this.physicalRooms.filter(
          (object) => object.id !== data.id
        );
        this.closeData();
        this.closeTooltip();
        this.stopLoader(this.$store);
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.createPhysicalPlantAndRoom")
        );
      },
      callbackError: (error) => {
        this.stopLoader(this.$store);
        this.onError(
          "",
          i18n.t("notifications.genericError.genericError", {
            code: error.response.status,
          })
        );
        console.log("TTT physicalPlantRemove KO ", error);
      },
    });
  }
  closeinfoPlant() {
    this.activeReserveRoomShow = false;
    this.activeReserveRoomEdit = false;
    this.plantName = "";
    this.roomName = "";
    this.rooms = [];
    this.plantImageUrl = null;
  }
  async physicalRoomSave(data) {
    this.startLoader(this.$store);
    if (data.id == 0)
      await this.$store.dispatch("SuperSpaceStore/createPhysicalRoomAction", {
        plantId: this.currentPlantId,
        data: { name: data.name },
        callback: (response) => {
          let physicalRoom = this.physicalRooms.find(
            (object) => object.id === this.currentPlantId
          );
          let room = physicalRoom.rooms.find((object) => object.id === 0);
          room.id = response.data.id;
          this.creatingRoom = false;
          this.stopLoader(this.$store);
          this.onSuccess(
            i18n.t("notifications.titles.success"),
            i18n.t("notifications.descriptions.createPhysicalPlantAndRoom")
          );
        },
        callbackError: (error) => {
          this.stopLoader(this.$store);
          this.onError(
            "",
            i18n.t("notifications.genericError.genericError", {
              code: error.response.status,
            })
          );
          console.log("TTT physicalRoomSave CREATE KO ", error);
        },
      });
    else
      await this.$store.dispatch("SuperSpaceStore/editPhysicalRoomAction", {
        roomId: data.id,
        data: { name: data.name },
        callback: (response) => {
          let physicalRoom = this.physicalRooms.find(
            (object) => object.id === this.currentPlantId
          );
          let room = physicalRoom.rooms.find((object) => object.id === data.id);
          room.id = response.data.id;
          room.name = response.data.name;
          this.creatingRoom = false;
          this.stopLoader(this.$store);
          this.onSuccess(
            i18n.t("notifications.titles.success"),
            i18n.t("notifications.descriptions.createPhysicalPlantAndRoom")
          );
        },
        callbackError: (error) => {
          this.stopLoader(this.$store);
          this.onError(
            "",
            i18n.t("notifications.genericError.genericError", {
              code: error.response.status,
            })
          );
          console.log("TTT physicalRoomSave EDIT KO ", error);
        },
      });
  }
  async physicalRoomRemove(data) {
    this.startLoader(this.$store);
    await this.$store.dispatch("SuperSpaceStore/removePhysicalRoomAction", {
      roomId: data.id,
      callback: (response) => {
        this.rooms = this.rooms.filter((object) => object.id !== data.id);
        let physicalRoom = this.physicalRooms.find(
          (object) => object.id === this.currentPlantId
        );
        physicalRoom.rooms = this.rooms;
        this.stopLoader(this.$store);
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.createPhysicalPlantAndRoom")
        );
      },
      callbackError: (error) => {
        this.stopLoader(this.$store);
        this.onError(
          "",
          i18n.t("notifications.genericError.genericError", {
            code: error.response.status,
          })
        );
        console.log("TTT physicalRoomRemove KO ", error);
      },
    });
  }
  closeTooltip() {
    const tooltip = document.getElementsByClassName("vs-tooltip");
    if (tooltip)
      while (tooltip.length > 0) {
        tooltip[0].parentNode.removeChild(tooltip[0]);
      }
  }
  closeData() {
    this.plantName = "";
    this.roomName = "";
    this.rooms = [];
    this.plantImageUrl = null;
  }
  async getAllSpaces(): Promise<void> {
    this.startLoader(this.$store);
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SpaceStore/getAllSpacesAction", {
      superSpaceId: space ? space.superSpace.id : this.superSpace.id,
      callback: (response) => {
        this.spacesDefault = response.data;
        this.stopLoader(this.$store);
      },
      callbackError: (error) => {
        console.log("TTTT getSpaces ERROR ", error);
        this.stopLoader(this.$store);
      },
    });
  }
  setSpaceDefault(spaceId: any) {
    this.startLoader(this.$store);
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SuperSpaceStore/setSpaceDefaultAction", {
      superSpaceId: space ? space.superSpace.id : this.superSpace.id,
      spaceId: spaceId,
      callback: (response) => {
        let newSuperSpace = this.superSpace;
        newSuperSpace.defaultSpace.id = spaceId;
        this.$store.dispatch(
          "SuperSpaceStore/setSuperSpacesAction",
          newSuperSpace
        );
        this.stopLoader(this.$store);
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.spaceUpdate")
        );
      },
      callbackError: (error) => {
        this.stopLoader(this.$store);
        this.onError(
          i18n.t("notifications.titles.error"),
          this.$i18n.t("notifications.genericError.genericErrorRetry")
        );
      },
    });
  }
  updatePlan() {
    if (!this.selectedPlans) return;
    let data = {
      ...this.selectedPlans,
      maxUsersConnected: +this.maxUsersConnected,
      maxSpaces: +this.maxSpaces,
      plan: this.plan,
    };
    this.startLoader(this.$store);
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SuperSpaceStore/setFeaturePlanAction", {
      superSpaceId: space ? space.superSpace.id : this.superSpace.id,
      data: data,
      callback: (response) => {
        this.stopLoader(this.$store);
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.spaceUpdate")
        );
      },
      callbackError: (error) => {
        this.stopLoader(this.$store);
        this.onError(
          i18n.t("notifications.titles.error"),
          this.$i18n.t("notifications.genericError.genericErrorRetry")
        );
      },
    });
  }
}
